<template>
  <div class="storeLocation">
    <LoadingModal />
    <Header :isShadow="false">
      <div slot="title"><van-icon name="location" />附近门店</div>
    </Header>
    <div class="store">
      <div
        class="list"
        v-for="item in storeList"
        :key="item.shopId"
        @click="clickHandle(item)"
      >
        <van-image
          class="img"
          width="60px"
          height="60px"
          radius="10px"
          fit="cover"
          :src="item.smallImageUrl"
        />
        <div class="title">{{ item.name }}</div>
        <div class="tag-list">
          <span class="tag" v-for="(tag, index) in tagList" :key="index">{{
            tag.name
          }}</span>
        </div>
        <van-divider style="padding: 0 5px" />
        <div class="address">
          <span class="pageFlex left">地址：{{ item.address }}</span>
          <div class="pageFlex">
            <van-icon name="location-o" size="16" />{{ item.distance }}km
          </div>
        </div>
        <!-- <span class="recommend">荐</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { wechatAuth } from "api/wechatSDK";
import { getStoreList } from "api/offLine";

export default {
  data() {
    return {
      latitude: "",
      longitude: "",
      storeList: [],
      tagList: [
        {
          name: "洗车",
        },
      ],
    };
  },
  created() {
    // console.log('init');
    wechatAuth(["getLocation"], this.getStoreList);
  },
  methods: {
    getStoreList() {
      let that = this;
      // console.log('getStoreList >>> ');
      wx.getLocation({
        type: "gcj02", // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'
        success: function (res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          getStoreList(that.longitude, that.latitude).then((res) => {
            if (res.status == 200) {
              that.storeList = res.data;
            } else {
              that.$error("获取门店失败，请稍后再试");
            }
          });
          that.$nextTick(() => {
            that.$store.commit("setPageLoading", false);
          });
        },
        // fail(res) {
        //   console.log(res);
        // },
        // complete(res) {
        //   console.log(res);
        // }
      });
    },
    clickHandle(item) {
      this.$store.commit("setStoreInfo", item);
      this.$push({
        path: "/storeInfo",
        query: {
          categoryId: this.$route.query.categoryId,
          categoryIdent: this.$route.query.categoryIdent,
          upstreamId: this.$route.query.upstreamId,
          buyerUserId: this.$route.query.buyerUserId,
          mouldId: this.$route.query.mouldId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.store {
  padding: 15px 20px;
  .list {
    border-radius: 10px;
    padding: 10px;
    background: #fff;
    color: #000;
    margin-bottom: 20px;
    position: relative;
    .img {
      position: absolute;
    }
    .title {
      margin-left: 70px;
    }
    .tag-list {
      margin: 5px 0 0 70px;
      .tag {
        margin: 0 5px 3px 0;
        padding: 1px 3px;
        display: inline-block;
        border: 1px solid #f3f1f1;
        border-radius: 3px;
        color: #888888;
        font-size: 12px;
      }
    }
    .address {
      margin-bottom: 5px;
      font-size: 12px;
      color: #888888;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .pageFlex {
        display: flex;
        align-items: center;
      }
      .left {
        width: 75%;
      }
    }
    .recommend {
      position: absolute;
      transform-origin: 100%;
      padding: 2px 4px;
      top: 0;
      right: 0;
      transform: translate(40%, -40%);
      border: 1px solid var(--redColor);
      border-radius: 999px;
      background: #fff;
      font-size: 12px;
      text-align: center;
      color: var(--redColor);
    }
  }
}
</style>
